@if (auftrag()) {
  <div class="soft-card soft-card-rounded-m shadow-m p-4"
       [class.first-in-group]="firstInGroup()"
       [class.last-in-group]="lastInGroup()"
       [attr.id]="auftrag()?.kopfau?.idkundenauftrag"
       [class.highlighted]="highlighted()"
       [ngClass]="auftrag()?.kopfau?.status === 'ABGESCHLOSSEN' ? 'finished-card' : 'dashboard-card'">
    <div class="primary-action" [ngClass]="saving() ? 'cursor-not-allowed' : ''" (click)="!saving() && emitStatusChange()">
      <i class="fas fa-4x" [ngStyle]="primaryActionStyle" [ngClass]="primaryActionIcon"></i>
    </div>
    <div class="primary-info c column no-wrap center-v" (click)="emitDetailNavigation()">
      <span class="soft-overline color-primary" style="font-size: 1rem;"><!--{{ auftrag()?.kopfau?.hauptartikel?.cartikelnummer }} | -->{{ auftrag()?.kopfau?.extbestellnr }}</span>
      <h3 class="soft-title mt-1">{{ auftrag()?.kopfau?.hauptartikel?.artbez1 }}</h3>
      <span class="soft-text-s color-light mt-1">{{ auftrag()?.kopfau?.kundenauftragsvkforg?.vkforg }} - {{ auftrag()?.kopfau?.kundenauftragsvkforg?.bez }}</span>
      <span class="soft-text-s color-light mt-1">{{ auftrag()?.kopfau?.verkaufsart?.verkaufsart }} - {{ auftrag()?.kopfau?.verkaufsart?.bezeichnung }}</span>
    </div>
    @if (auftrag()?.kopfau?.status !== 'ABGESCHLOSSEN') {
      <div class="secondary-info" (click)="emitDetailNavigation()">
        {{ auftrag()?.kopfau?.lieferhinweis }}
      </div>
      <div class="c column center-v no-wrap date" (click)="emitDetailNavigation()">
        <span class="soft-text-s color-light padding-compact">{{ auftrag()?.kopfau?.belegdatum | date:'dd.MM.YYYY' }}</span>
        <span class="soft-text">{{ auftrag()?.kopfau?.abholdatum | date:'dd.MM.YYYY' }}</span>
      </div>
    }
    <div class="detail-indicator" (click)="emitDetailNavigation()">
      <i class="fas fa-chevron-right color-light"></i>
    </div>
  </div>
}
